import {
	ProductListingCard,
	TProductListingCardProps,
} from "@/components/common/product-listing-card";
import { useProductEngagement } from "@/hooks/useProductEngagement";

type TProductsSectionProps = {
	heading: React.ReactNode;
	products: TProductListingCardProps[];
};

const ProductWithRatingAndReviewsCount = (product: TProductListingCardProps) => {
	const { rating, reviewsCount, commentsCount } = useProductEngagement(product.slug);

	return (
		<ProductListingCard
			{...product}
			totalRating={Number(rating)}
			reviewsCount={reviewsCount}
			commentsCount={commentsCount}
		/>
	);
};

export const ProductsSection = ({ heading, products }: TProductsSectionProps) => {
	return (
		<div>
			<div className="gap- mb-7 flex flex-col-reverse flex-wrap items-start justify-start gap-4 md:flex-row md:flex-nowrap md:items-center">
				{heading}
			</div>

			<div className="col-span-4 grid h-fit grid-cols-1 md:space-y-5 lg:col-span-3">
				{products.map((product) => (
					<ProductWithRatingAndReviewsCount key={product.id} {...product} />
				))}
			</div>
		</div>
	);
};
